import { apiService } from '../../shared/services/apiService';
import { WhatsNewContent, WhatsNewStatus } from '../interface/whatsNew';

export const whatsNewService = {
  async getContent(userId: number) {
    const resp = await apiService.get<WhatsNewContent>(
      `/api/users/${userId}/one-time-action/whats-new/content`,
    );

    return resp.data;
  },

  async getShowStatus(userId: number, isRunGlobalSpinner = false) {
    const resp = await apiService.get<WhatsNewStatus>(
      `/api/users/${userId}/one-time-action/whats-new`,
      { isRunGlobalSpinner },
    );

    return resp.data;
  },
};
